const projectDetailPageDelayAnnouncement = {
  slideTimeout: 3000,
  translateX: -196,
  translateY: 0,
  headingText: 'INTRODUCING DELAYS',
  bodyText: 'Explore the delays tab to learn more!',
  buttonText: 'GOT IT',
  contents_allignment: 'left-right',
  circlePositionOnScreen: 'right',
  swoopArrowSettings: {
    left: 16,
    top: 7,
    rotate: -142,
    rotateY: 0,
  },
  highlightSettings: {
    top: -45,
    right: 79,
    width: 101,
    height: 100,
  },
};

const DelaysPageAnnouncement = {
  slideTimeout: 500,
  translateX: 220,
  translateY: 0,
  headingText: 'WELCOME TO DELAYS',
  bodyText: 'You can see previously reported Delays here. Select Report A Delay to add a new one.',
  buttonText: 'GOT IT',
  contents_allignment: 'center',
  circlePositionOnScreen: 'left',
  swoopArrowSettings: {
    left: 44,
    top: 12,
    rotate: -7,
    rotateY: 0,
  },
  highlightSettings: {
    left: (window.innerWidth / 2) - 87,
    bottom: -62,
    width: 250,
    height: 100,
  },

};

const DelayTypePageAnnouncement = {
  slideTimeout: 500,
  translateX: 0,
  translateY: 140,
  headingText: 'CATEGORIZE YOUR DELAY',
  bodyText: 'Select the type of delay that you\'re experiencing.',
  buttonText: 'GOT IT',
  contents_allignment: 'center-top',
  circlePositionOnScreen: 'top',
  swoopArrowSettings: {
    left: 44,
    top: 29,
    rotate: 15,
    rotateY: 0,
  },
  highlightSettings: {
    height: 'calc(100vw - 20px)',
    width: 'calc(100vw - 20px)',
    top: 270,
    right: 10,
  },

};

const DelayDetailsDocumentAnnouncement = {
  slideTimeout: 500,
  translateX: -196,
  translateY: 0,
  headingText: 'ADD RELEVANT INFO',
  bodyText: 'Document the details of your delay. And don\'t forget to add a few photos.',
  buttonText: '',
  contents_allignment: 'left-right-top',
  circlePositionOnScreen: 'right-absolute',
  swoopArrowSettings: {
    left: 29,
    top: 25,
    rotate: 31,
    rotateY: 180,
  },
  highlightSettings: {
    bottom: -80,
    left: 69,
    width: 130,
    height: 111,
  },

};

const DelayDetailsDoneAnnouncement = {
  slideTimeout: 500,
  translateX: 220,
  translateY: 0,
  headingText: 'WITH THE PRESS OF A BUTTON',
  bodyText: 'Once submitted, Project members can see this info on mobile and web!',
  buttonText: 'DONE!',
  contents_allignment: 'center',
  circlePositionOnScreen: 'left-absolute',
  swoopArrowSettings: {
    left: 44,
    top: 12,
    rotate: -7,
    rotateY: 0,
  },
  highlightSettings: {
    left: (window.innerWidth / 2) - 87,
    width: 250,
    height: 106,
    bottom: -79,
  },

};

export default{
  projectDetailPageDelayAnnouncement,
  DelaysPageAnnouncement,
  DelayTypePageAnnouncement,
  DelayDetailsDocumentAnnouncement,
  DelayDetailsDoneAnnouncement,
};



// WEBPACK FOOTER //
// ./src/constants/AnnouncementWalkthroughSettings.js